import React from "react";
import { Col, Row } from "react-bootstrap";
import FundtransferBtn from "./FundtransferBtn";
import { useNavigate } from "react-router-dom";
import DeviceContext from "@/components/generic/customHooks/indentifyDevice";
import config from "@/config/domain";
interface IlistData {
  listcontent: React.ReactNode;
}
interface IPaymentOnUPI {
  headSection: string;
  subheadSection: React.ReactNode;
  asideSection: React.ReactNode;
  liData?: IlistData[];
  upiStepsList?: IlistData[];
  btnshow?: boolean;
}

const PaymentOnUPI = (props: IPaymentOnUPI) => {
  const device = DeviceContext();
  const navigate = useNavigate();
  return (
    <>
      <Row className="px-3">
        <Col
          lg={12}
          className="mgt-15 d-flex align-items-center justify-content-center"
        >
          <span className="DMSansMedium_20_500 txt-midnight-blue">
            {props.headSection}
          </span>
        </Col>
        <Col lg={12} className="mgt-15 text-center">
          <span className="DMSan_14_500 txt_blackOne1">
            {props.subheadSection}
          </span>
        </Col>
        {props?.asideSection && (
          <Col lg={12} className="mgt-30">
            <span>{props.asideSection}</span>
          </Col>
        )}
        {!window.location.href.includes("TX3") &&
          !window.location.href.includes("paylink") &&
          !window.location.href.includes("paylink") && (
            <Col lg={12} className="mt-5">
              {props.upiStepsList && (
                <span className="DMSansMedium_12_500 txt-midnight-blue">
                  Steps to follow
                </span>
              )}
            </Col>
          )}
        <Col lg={12} className="mgt-10">
          <ul className="disc-style color-gray ">
            {props.upiStepsList?.map((listData, idx) => {
              return (
                <>
                  <li>{listData.listcontent}</li>
                </>
              );
            })}
          </ul>
        </Col>
        {!window.location.href.includes("TX3") &&
          !window.location.href.includes("paylink") &&
          !window.location.href.includes("paylink") && (
            <>
              <br />
              <br />
              <br />
              <Col lg={12} className="mgt-10">
                <ul className="disc-style color-gray ">
                  {props.liData.map((listData, idx) => {
                    return (
                      <>
                        <li>{listData.listcontent}</li>
                      </>
                    );
                  })}
                </ul>
              </Col>
            </>
          )}
      </Row>
      {props.btnshow ? (
        <>
          {" "}
          <Row>
            <Col>
              <div>
                <FundtransferBtn
                  btnvalueleft={{
                    value: "Cancel",
                    btnTyp: "midnight-blue-underline",
                    className: "w-100 me-2 editcancel ",
                    onClick: () => {
                      navigate("/fund-transfer");
                    },
                  }}
                  btnvalueright={{
                    value: "Add Funds",
                    btnTyp: "midnight-blue",
                    className: "w-100 ms-2 ",
                  }}
                  parentClass={
                    device && device.isDesktop
                      ? "topborder common-fixedbtm-btm-desktop p-4"
                      : "topborder col-sm-12 common-fixedbtm-btn p-4"
                  }
                />
              </div>
            </Col>
          </Row>
        </>
      ) : null}
    </>
  );
};

export default PaymentOnUPI;
